import { triggerToast } from '@components/base/Notification';
import * as Sentry from '@sentry/react';
const timeoutToastContent = {
    title: 'Request timed out',
    summary: 'The request took too long. Please refresh and try again.',
};
export const catchError = (props) => {
    const isTimeOutError = typeof props?.error?.message === 'string' ? props?.error?.message.toLowerCase().includes('timeout') : false;
    console.error(`${props?.title} error: `, props?.error?.message);
    if (!props.skipToast) {
        triggerToast({
            message: {
                title: isTimeOutError ? timeoutToastContent.title : props?.title,
                summary: isTimeOutError ? timeoutToastContent.summary : props?.error?.message,
            },
            variant: 'danger',
        });
    }
    if (props.skipSentry) {
        return '';
    }
    if (props?.extraScope && props.extraScope?.key && props.extraScope?.value) {
        const { key, value } = props.extraScope;
        return Sentry.withScope((scope) => {
            scope.setTag(key, value);
            return Sentry.captureException(props?.error);
        });
    }
    return Sentry.captureException(props?.error);
};
// Reports a non-fatal condition to Sentry without throwing.
export const captureMessage = (message, context) => {
    if (context) {
        return Sentry.withScope((scope) => {
            scope.setContext('details', context);
            return Sentry.captureMessage(message, 'warning');
        });
    }
    return Sentry.captureMessage(message, 'warning');
};
export const sentrySetUser = (user) => {
    Sentry.setUser({
        id: (user?.user_id && Number(user?.user_id)),
        tenant_id: user?.tenant_id && Number(user?.tenant_id),
    });
};
export const withTracingSpan = (action, type = 'cx-transaction', callback) => {
    const spanName = action || 'anonymous_transaction';
    return Sentry.startNewTrace(() => Sentry.startSpan({
        name: spanName,
        op: type,
    }, (span) => callback(span)));
};
const formatTraceHeader = (span) => {
    if (!span)
        return null;
    if (typeof span.spanContext !== 'function')
        return null;
    const context = span.spanContext();
    if (!context?.traceId || !context?.spanId)
        return null;
    const sampledFlag = 'sampled' in context ? (context.sampled === false ? '0' : '1') : '1';
    return `${context.traceId}-${context.spanId}-${sampledFlag}`;
};
export const getPropagationContext = (operationName, operationType) => {
    const name = operationName || 'anonymous';
    const type = operationType || 'query';
    const parentSpan = Sentry.getActiveSpan();
    const spanOptions = {
        name: `graphql.${type}.${name}`,
        op: 'graphql',
        attributes: {
            'graphql.operation.name': name,
            'graphql.operation.type': type,
        },
    };
    if (parentSpan) {
        const childSpan = Sentry.startInactiveSpan({
            ...spanOptions,
            parentSpan,
        });
        return {
            span: childSpan,
            traceHeader: formatTraceHeader(childSpan),
        };
    }
    const detachedSpan = Sentry.startInactiveSpan({
        ...spanOptions,
        forceTransaction: true,
    });
    return {
        span: detachedSpan,
        traceHeader: formatTraceHeader(detachedSpan),
    };
};
